import { render, staticRenderFns } from "./SideBarOffshore.vue?vue&type=template&id=5e0125f0"
import script from "./SideBarOffshore.vue?vue&type=script&lang=js"
export * from "./SideBarOffshore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports